// === NAV TOGGLE ===
var navToggle = document.getElementById('nav-toggle');
if (navToggle) {
  navToggle.addEventListener('click', function() {
    document.getElementById('main-nav').classList.toggle('open');
  });
}

// === SMOOTH SCROLL ===
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var nav = document.getElementById('main-nav');
      if (nav) nav.classList.remove('open');
    }
  });
});

// === CART COUNT ===
fetch('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var badge = document.querySelector('.cart-count');
    if (badge) badge.textContent = cart.item_count;
  });

// === QUANTITY INPUTS IN CART ===
document.querySelectorAll('.qty-input').forEach(function(input) {
  input.addEventListener('change', function() {
    var line = this.dataset.line;
    var qty = parseInt(this.value);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: qty })
    }).then(function() { location.reload(); });
  });
});

// === CONTACT FORM ===
var contactForm = document.getElementById('contact-form');
if (contactForm) {
  contactForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = this.querySelector('.form-submit');
    btn.textContent = 'Verzenden...';
    btn.disabled = true;
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(this))
    }).then(function(r) {
      if (r.ok || r.redirected) {
        document.getElementById('form-success').style.display = 'block';
        contactForm.reset();
      } else {
        document.getElementById('form-error').style.display = 'block';
      }
      btn.disabled = false;
      btn.textContent = 'Verstuur bericht';
    }).catch(function() {
      document.getElementById('form-error').style.display = 'block';
      btn.disabled = false;
      btn.textContent = 'Verstuur bericht';
    });
  });
}
